import { formatCurrency, formatMonth, getMonthKey } from '../../config/resources/utils'

export const NOTIFICATION_TYPE = {
  PENSION_GENERATED: 'PENSION_GENERATED',
  PENSION_UPDATED: 'PENSION_UPDATED',
  PAYMENT_REMINDER: 'PAYMENT_REMINDER',
}

const TYPE_LABELS = {
  [NOTIFICATION_TYPE.PENSION_GENERATED]: 'Cálculo',
  [NOTIFICATION_TYPE.PENSION_UPDATED]: 'Monto actualizado',
  [NOTIFICATION_TYPE.PAYMENT_REMINDER]: 'Recordatorio',
}

const REGISTER_PAYMENT_LABEL = 'Registrar pago'
const VIEW_AMOUNT_LABEL = 'Ver el monto'

const asMetadata = (value) =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {}

const trimString = (value) => {
  if (typeof value !== 'string') return ''
  const trimmed = value.trim()
  return trimmed
}

export const getNotificationSubject = (notif) => {
  const metadata = asMetadata(notif?.metadata)
  return (
    trimString(notif?.title) ||
    trimString(metadata.subject) ||
    trimString(metadata.inboxTitle) ||
    trimString(metadata.name) ||
    'Sin asunto'
  )
}

export const getNotificationMessage = (notif) => {
  const metadata = asMetadata(notif?.metadata)
  return (
    trimString(notif?.message) ||
    trimString(metadata.inboxMessage) ||
    trimString(metadata.email) ||
    ''
  )
}

export const formatNotificationDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return ''

  return date.toLocaleString('es-CL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

const formatAmountFact = (value) => {
  if (value == null || value === '') return ''
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return ''
    if (trimmed.startsWith('$')) return trimmed
  }

  const formatted = formatCurrency(value)
  return formatted === '—' ? '' : formatted
}

const formatMonthFact = (value) => {
  if (!value) return ''
  const month = formatMonth(value)
  if (!month) return ''
  const year = getMonthKey(value)?.slice(0, 4)
  return year ? `${month} de ${year}` : month
}

const buildFacts = (metadata) => {
  const facts = []
  const amount = formatAmountFact(metadata.pensionValue)
  if (amount) {
    facts.push({ key: 'amount', label: 'Monto', value: amount })
  }

  const month = formatMonthFact(metadata.targetMonth || metadata.target_month)
  if (month) {
    facts.push({ key: 'month', label: 'Mes', value: month })
  }

  const paymentDay = trimString(metadata.paymentDayLabel)
  if (paymentDay) {
    facts.push({ key: 'paymentDay', label: 'Día de pago', value: paymentDay })
  }

  return facts
}

const buildCta = (type, metadata) => {
  if (type === NOTIFICATION_TYPE.PAYMENT_REMINDER) {
    return { label: REGISTER_PAYMENT_LABEL, focusPayment: true }
  }

  const label =
    trimString(metadata.ctaLabel) ||
    (type === NOTIFICATION_TYPE.PENSION_GENERATED ||
    type === NOTIFICATION_TYPE.PENSION_UPDATED
      ? VIEW_AMOUNT_LABEL
      : '')

  if (!label) return null

  return {
    label,
    focusPayment: label === REGISTER_PAYMENT_LABEL,
  }
}

/**
 * End-user view model for the notification drawer.
 * Does not expose raw jsonb, email ids, or ctaUrl.
 */
export const buildNotificationDetail = (notif) => {
  if (!notif) return null

  const metadata = asMetadata(notif.metadata)
  const typeLabel = TYPE_LABELS[notif.type] || 'Aviso'
  const cta = buildCta(notif.type, metadata)

  return {
    id: notif.id,
    title: getNotificationSubject(notif),
    message: getNotificationMessage(notif),
    typeLabel,
    createdAtLabel: formatNotificationDate(notif.created_at),
    facts: buildFacts(metadata),
    cta,
  }
}
